import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  auto: {
    loading: true,
    loadingQuotes: false,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],

    driverForm: false,
    ownerForm: false,
  },
  autocarro: {
    loading: true,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],
    vehicleActivities: [],

    driverForm: false,
    ownerForm: false,
  },
  moto: {
    loading: true,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],
    vehicleActivities: [],

    driverForm: false,
    ownerForm: false,
  },
  profession: {
    loading: true,
    states: [],
    municipalities: [],
    professions: [],
    selectedProfession: null,
    formData: {},
    dataPrivacy: [],
  },
  infortuni: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    dataPrivacy: [],

    pack: '',
    isActive: '',
    index: 1,
    isEntry: false,
    requestToken: '',
  },
  travel: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
    travel_states: [],
  },
  salute: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  house: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  tutela_legale: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  sanitaria_stranieri: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  public_employment: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  professione_sanita: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  ancillari: {
    loading: true,
    loadingQuotes: false,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    vehicleModels: [],
    dataPrivacy: [],
    brands: [],
    formData: {
      qualifications: [],
      professions: [],
      parking_types: [],
      theft_protections: [],
      marital_statuses: [],
      insurance_companies: [],
      company_types: [],
    },
    vehicleVersions: [],

    driverForm: false,
    ownerForm: false,
  },
  malattia: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  commercial: {
    loading: true,
    loadingQuotes: false,
    isLoadingVehicleModels: false,
    isLoadingVehicleVersions: false,
    isLoadingFastQuote: false,
    isSubmitting: false,
    index: 1,
    states: [],
    municipalities: [],
    dataPrivacy: [],
  },
  infortunio: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  condominio: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  rc_famiglia: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
  monopattini: {
    loading: true,
    states: [],
    municipalities: [],
    formData: {},
    dataPrivacy: [],
  },
};

export const formsBackofficeSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    autoFormDataUpdated: (state, { payload }) => {
      state.auto = { ...state.auto, ...payload };
    },
    commercialUpdated: (state, { payload }) => {
      state.commercial = { ...state.commercial, ...payload };
    },
    resetAutoForm: (state) => {
      state.auto = { ...initialState.auto };
    },
    autocarroFormDataUpdated: (state, { payload }) => {
      state.autocarro = { ...state.autocarro, ...payload };
    },
    resetAutocarroForm: (state) => {
      state.autocarro = { ...initialState.autocarro };
    },
    motoFormDataUpdated: (state, { payload }) => {
      state.moto = { ...state.moto, ...payload };
    },
    resetMotoForm: (state) => {
      state.moto = { ...initialState.moto };
    },
    professionFormDataUpdated: (state, { payload }) => {
      state.profession = { ...state.profession, ...payload };
    },
    resetProfessionForm: (state) => {
      state.profession = { ...initialState.profession };
    },
    infortuniFormDataUpdated: (state, { payload }) => {
      state.infortuni = { ...state.infortuni, ...payload };
    },
    resetInfortuniForm: (state) => {
      state.infortuni = { ...initialState.infortuni };
    },
    travelFormDataUpdated: (state, { payload }) => {
      state.travel = { ...state.travel, ...payload };
    },
    resetTravelForm: (state) => {
      state.travel = { ...initialState.travel };
    },
    saluteFormDataUpdated: (state, { payload }) => {
      state.salute = { ...state.salute, ...payload };
    },
    resetSaluteForm: (state) => {
      state.salute = { ...initialState.salute };
    },
    publicEmploymentFormDataUpdated: (state, { payload }) => {
      state.public_employment = { ...state.public_employment, ...payload };
    },
    resetPublicEmploymentForm: (state) => {
      state.public_employment = { ...initialState.public_employment };
    },
    professioneSanitaFormDataUpdated: (state, { payload }) => {
      state.professione_sanita = { ...state.professione_sanita, ...payload };
    },
    resetProfessioneSanitaForm: (state) => {
      state.professione_sanita = { ...initialState.professione_sanita };
    },
    houseFormDataUpdated: (state, { payload }) => {
      state.house = { ...state.house, ...payload };
    },
    resetHouseForm: (state) => {
      state.house = { ...initialState.house };
    },
    resetCommercialForm: (state) => {
      state.commercial = { ...initialState.commercial };
    },
    tutelaLegaleFormDataUpdated: (state, { payload }) => {
      state.tutela_legale = { ...state.tutela_legale, ...payload };
    },
    resetTutelaLegaleForm: (state) => {
      state.tutela_legale = { ...initialState.tutela_legale };
    },
    sanitariaStranieriFormDataUpdated: (state, { payload }) => {
      state.sanitaria_stranieri = { ...state.sanitaria_stranieri, ...payload };
    },
    resetSanitariaStranieriForm: (state) => {
      state.sanitaria_stranieri = { ...initialState.sanitaria_stranieri };
    },
    ancillariFormDataUpdated: (state, { payload }) => {
      state.ancillari = { ...state.ancillari, ...payload };
    },
    resetAncillariForm: (state) => {
      state.ancillari = { ...initialState.ancillari };
    },
    malattiaFormDataUpdated: (state, { payload }) => {
      state.malattia = { ...state.malattia, ...payload };
    },
    resetMalattiaForm: (state) => {
      state.malattia = { ...initialState.malattia };
    },
    infortunioFormDataUpdated: (state, { payload }) => {
      state.infortunio = { ...state.infortunio, ...payload };
    },
    resetInfortunioForm: (state) => {
      state.infortunio = { ...initialState.infortunio };
    },
    condominioFormDataUpdated: (state, { payload }) => {
      state.condominio = { ...state.condominio, ...payload };
    },
    resetCondominioForm: (state) => {
      state.condominio = { ...initialState.condominio };
    },
    rcFamigliaFormDataUpdated: (state, { payload }) => {
      state.rc_famiglia = { ...state.rc_famiglia, ...payload };
    },
    resetRcFamigliaForm: (state) => {
      state.rc_famiglia = { ...initialState.rc_famiglia };
    },
    monopattiniFormDataUpdated: (state, { payload }) => {
      state.monopattini = { ...state.monopattini, ...payload };
    },
    resetMonopattiniForm: (state) => {
      state.monopattini = { ...initialState.monopattini };
    },
  },
});

export default callerCreator(formsBackofficeSlice.actions);
